import "./index.css";
import "dayjs/locale/ru";
import "react-photo-view/dist/react-photo-view.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider } from "@mui/material";
import { LocalizationProvider, ruRU } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import App from "./App.jsx";
import { setupStore } from "./store";
import { theme } from "./theme";

const localeText = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;

const root = ReactDOM.createRoot(document.getElementById("root"));

const store = setupStore();

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<LocalizationProvider dateAdapter={AdapterDayjs} localeText={localeText} adapterLocale="ru">
				<ThemeProvider theme={theme}>
					<App />
				</ThemeProvider>
			</LocalizationProvider>
		</BrowserRouter>
	</Provider>
);
